import { buyShopOffer } from '@patrianna-payments/shared-store/payments/store/middleware-actions'
import type { OfferInfo } from '@patrianna-payments/shared-store/payments/types/openApiModels/OfferInfo'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

import { getSnowplowPaymentFlow } from 'src/analyticActions/common/trackPaymentSnowplow'
import { useAppDispatch } from 'store/hooks'

export const useReturnToCashier = () => {
  const dispatch = useAppDispatch()
  const { push } = useRouter()

  return useCallback(
    (offerCode: string) => {
      dispatch(
        buyShopOffer({
          offer: { code: offerCode } as OfferInfo,
          routerPush: push,
          snowplowPayFlow: getSnowplowPaymentFlow(),
        }),
      )
    },
    [push],
  )
}
